import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Address.css";

const Address = () => {
  const [fetchedData, setFetchedData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/Kalanjiyam_ContactUs"
      );
      console.log(response.data);
      setFetchedData(response.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="address-container py-5">
      <h2 className="address-title text-center mb-4">
        Contact Us For Any Questions
      </h2>
      <div className="row">
        {fetchedData?.map((item) => (
          <>
            <div className="col-md-4 text-center mb-4">
              <h5 className="address-subtitle">{item.title}</h5>
              <p className="address-text">{item.email}</p>
              <p className="address-text">{item.mobile}</p>
              <p className="address-text">{item.location}</p>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default Address;
